import axios from 'axios'

export default {
  list (context, opts) {
    const options = opts ? { params: opts } : {}
    return new Promise((resolve, reject) => {
      axios
        .get('/api/client', options)
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  }
}
